import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { shouldShowRoomsRemainingLabelForVariant } from './urgencyLabelVisibility'

type RoomThreshhold = 'rate' | 'default'
type RoomsRemainingCopyVariant = 'room-count' | 'rate-price'

interface Props {
  roomCount: number
  /**
   * Formatted first-rate price for the SPP room tile rate-price copy variant.
   */
  ratePrice?: ReactNode
  /**
   * @default room-count
   */
  copyVariant?: RoomsRemainingCopyVariant
  className?: string
  /**
   * Threshhold at which to apply the label
   * @default default
   */
  threshold?: RoomThreshhold
}

function RoomsRemainingLabel(props: Props) {
  const { roomCount, ratePrice, copyVariant = 'room-count', className, threshold = 'default' } = props

  // CRO team SPP urgent rooms test displays the room urgency copy with the selected rate price.
  const shouldShowRatePrice = copyVariant === 'rate-price'

  if (!shouldShowRoomsRemainingLabelForVariant({ roomCount, hasRatePrice: !!ratePrice, threshold, copyVariant })) {
    return null
  }

  return <UrgencyLabel className={className} variant="speed">
    {shouldShowRatePrice && <FormattedMessage
      id="WLfwsmRQ_ty5iUbo6a-L"
      defaultMessage="Limited rooms left at {ratePrice}"
      description="Urgency label showing limited room availability at a selected property room rate price"
      values={{ ratePrice }}
    />}
    {!shouldShowRatePrice && <FormattedMessage
      id="g8Lk4bWqJBjAZpSTitS7"
      defaultMessage="{count, plural, one {# room} other {# rooms}} left"
      description="Urgency label showing number of rooms remaining in the labels section"
      values={{ count: roomCount }}
    />}
  </UrgencyLabel>
}

export default RoomsRemainingLabel
